// extracted by mini-css-extract-plugin
export default {"label":"Label_label__16uKP","required":"Label_required__wZwYL"};